import { ENROLL_HARD, ENTER_EXTENDED_AVAILABILITITES, MANAGE_CONFIG, VIEW_FESTIVAL_EVENTS_STATS, VIEW_USEFUL_LINKS } from "@overbookd/permission";
// src/keys.ts
const REGISTRATION_FORM_KEY = "registrationForm";
const EVENT_DATE_KEY = "eventDate";
const ORGA_WEEK_DATE_KEY = "orgaWeekDate";
const INVITE_STAFF_LINK_KEY = "inviteStaffLink";
const USEFUL_LINKS_KEY = "usefulLinks";
const LAST_EDITION_FESTIVAL_EVENT_STATS_KEY = "lastEditionFestivalEventStats";
const configurationKeys = [
	REGISTRATION_FORM_KEY,
	EVENT_DATE_KEY,
	ORGA_WEEK_DATE_KEY,
	INVITE_STAFF_LINK_KEY,
	USEFUL_LINKS_KEY,
	LAST_EDITION_FESTIVAL_EVENT_STATS_KEY
];
// src/permissions.ts
const ALL = "ALL";
const NONE = "NONE";
const configurationsWithPermissions = [
	{
		key: REGISTRATION_FORM_KEY,
		permissions: {
			read: ALL,
			write: MANAGE_CONFIG
		}
	},
	{
		key: EVENT_DATE_KEY,
		permissions: {
			read: ALL,
			write: MANAGE_CONFIG
		}
	},
	{
		key: ORGA_WEEK_DATE_KEY,
		permissions: {
			read: ENTER_EXTENDED_AVAILABILITITES,
			write: MANAGE_CONFIG
		}
	},
	{
		key: INVITE_STAFF_LINK_KEY,
		permissions: {
			read: ENROLL_HARD,
			write: ENROLL_HARD
		}
	},
	{
		key: USEFUL_LINKS_KEY,
		permissions: {
			read: VIEW_USEFUL_LINKS,
			write: MANAGE_CONFIG
		}
	},
	{
		key: LAST_EDITION_FESTIVAL_EVENT_STATS_KEY,
		permissions: {
			read: VIEW_FESTIVAL_EVENTS_STATS,
			write: MANAGE_CONFIG
		}
	}
];
function canReadConfiguration(key, permissions = []) {
	const config = configurationsWithPermissions.find((c) => c.key === key);
	if (!config) return false;
	const read = config.permissions.read;
	if (read === ALL) return true;
	if (read === NONE) return false;
	return permissions.some((p) => p === read);
}
function canWriteConfiguration(key, permissions = []) {
	const config = configurationsWithPermissions.find((c) => c.key === key);
	if (!config) return false;
	const write = config.permissions.write;
	if (write === ALL) return true;
	if (write === NONE) return false;
	return permissions.some((p) => p === write);
}
export { EVENT_DATE_KEY, INVITE_STAFF_LINK_KEY, LAST_EDITION_FESTIVAL_EVENT_STATS_KEY, ORGA_WEEK_DATE_KEY, REGISTRATION_FORM_KEY, USEFUL_LINKS_KEY, canReadConfiguration, canWriteConfiguration, configurationKeys };

//# sourceMappingURL=index.mjs.map